import { addBenchmarksPeriod } from './add-benchmarks-period';
import { getBenchmarksList } from './get-benchmarks-list';
import { updateBenchmarksById } from './update-benchmarks-by-id';

export const actions = {
  getBenchmarksList,
  addBenchmarksPeriod,
  updateBenchmarksById,
};
